import { render, staticRenderFns } from "./quantitativeProtocol.vue?vue&type=template&id=88803684&scoped=true&"
import script from "./quantitativeProtocol.vue?vue&type=script&lang=js&"
export * from "./quantitativeProtocol.vue?vue&type=script&lang=js&"
import style0 from "./quantitativeProtocol.vue?vue&type=style&index=0&id=88803684&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88803684",
  null
  
)

export default component.exports